import { render, staticRenderFns } from "./DmAdressen.vue?vue&type=template&id=4fac1e42&scoped=true&"
import script from "./DmAdressen.vue?vue&type=script&lang=js&"
export * from "./DmAdressen.vue?vue&type=script&lang=js&"
import style0 from "./DmAdressen.vue?vue&type=style&index=0&id=4fac1e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fac1e42",
  null
  
)

export default component.exports